import {
  Button,
  Chip,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Radio,
  RadioGroup,
  Select,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { fDate } from "../../../../../utils/formatTime";
import ReceiptIcon from "@mui/icons-material/Receipt";
import PaymentIcon from "@mui/icons-material/Payment";
import CancelIcon from "@mui/icons-material/Cancel";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import PaymentPopup from "./PaymentPopup";
import PaymentForm from "./PaymentForm";
import CustomSnackbar from "../../../../../newTestPrep/components/ui-component/snackbar/CustomSnackbar";
import { Link } from "react-router-dom";
import StyledTableContainer from "../../../../../newTestPrep/newComponent/TableContainer";
import ArrowDropDownCircleIcon from '@mui/icons-material/ArrowDropDownCircle';
import PlanStatusForm from "./PlanStatusForm";
import CustomPopup from "../../../../../components/CustomPopup";
import CancelPayment from "../../../../../newTestPrep/pages/payments/miscellaneousPayment/CancelPayment";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

function EnquiryPayments({ payments, enquiryId, loading, isReadOnly,     miscellaneousPaymentLoading, 
                miscellaneousPayment,selectedSubService }) {
               
                  console.log("miscellaneousPayment",miscellaneousPayment)
  const userId = localStorage.getItem("userId");
  const userRole = localStorage.getItem("userRole");
  const [data, setData] = useState(payments);

  const [refundDialogOpen, setRefundDialogOpen] = useState(false);
  const [refundType, setRefundType] = useState("full");
  const [refundAmount, setRefundAmount] = useState("");
  const [refundReason, setRefundReason] = useState("");
  const [open, setOpen] = useState(false);
  const [openPlanStatus, setOpenPlanStatus] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
    const [opencancel, setOpenCancel] = useState(false);
  const [selectedMisRowId, setSelectedMisRowId] = useState(null);
  
  const [newLinkdialogOpen, setnewLinkdialogOpen] = useState(false);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");

    const handleOpenCancelPopup = (rowId) => {
    setOpenCancel(true);
    setSelectedMisRowId(rowId)
   
  };

  const handleCloseCanclePopup = () => {
    setOpenCancel(false);
  };


  const showSnackbar = (message, severity) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleOpen = (row) => {
    if (userRole !== "advisor") {
      showSnackbar(
        "Please login as an advisor role,to generate new pending payment request",
        "error"
      );
      return;
    }
    setSelectedRow(row);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpenPlanStatus = (row) => {
    if (userRole !== "advisor") {
      showSnackbar(
        "Please login as an advisor role to change plan status",
        "error"
      );
      return;
    }
    setSelectedRow(row);
    setOpenPlanStatus(true);
  };

  const handleClosePlanStatus = () => {
    setOpenPlanStatus(false);
  };

  const handleInitiateRefund = (row) => {
    setRefundDialogOpen(true);
  };

  const handleRefundDialogClose = () => {
    setRefundDialogOpen(false);
    // Reset refund-related state variables
    setRefundType("full");
    setRefundAmount("");
    setRefundReason("");
  };

  const handleRefundSubmit = () => {
    handleRefundDialogClose();
  };

  const handleCancelPayment = (id) => {
    fetch(`${API_ENDPOINT}lmprovesionpayment/${id}`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        payment_status: "cancelled",
        is_active: 0,
        user_id: userId,
        is_cancelled: true,
      }),
    })
      .then((response) => {
        if (response.ok) {
          // Handle success, e.g., show a success message
          console.log("Payment cancelled successfully");
          // alert('Payment Details sent successfully')
          showSnackbar("Payment cancelled successfully", "success");
        } else {
          // Handle failure, e.g., show an error message
          console.error("Failed to cancel request");
          showSnackbar("Failed to cancel request", "error");
          //alert('Error sending payment details')
        }
      })
      .catch((error) => {
        console.error("Error cancelling request:", error);
        showSnackbar("Error cancelling request", "error");
        // alert('Error sending payment details')
      });
  };

  const handleGenerateNewPaymentLink = (row) => {
    setSelectedRow(row);
    setnewLinkdialogOpen(true);
  };

  const handleGeneratePaymentLink = () => {
    const id = selectedRow.id;
    const data = {
      amount_paid: selectedRow.amount_paid,
      enquiry_id: selectedRow.enquiry_id,
      class_id: selectedRow.class_id.id,
      package_id: selectedRow.package_id.id,
      user_id: userId,
    };
    fetch(`${API_ENDPOINT}lmprovesionpayment/recreaterazorpaylink/${id}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (response.ok) {
          // Handle success, e.g., show a success message
          console.log("Payment Link created successfully");
          // alert('Payment Details sent successfully')
          handlenewLinkCloseDialog();
          showSnackbar("Payment Link created successfully", "success");
        } else {
          // Handle failure, e.g., show an error message
          console.error("Failed to create link");
          showSnackbar("Failed to create payment link", "error");
          //alert('Error sending payment details')
        }
      })
      .catch((error) => {
        console.error("Error creating payment link:", error);
        showSnackbar("Error creating payment link", "error");
        // alert('Error sending payment details')
      });
  };

  const handlenewLinkCloseDialog = () => {
    setSelectedRow(null);
    setnewLinkdialogOpen(false);
  };

  const copyLinkToClipboard = (row) => {
    const link = row?.payment_link_object?.short_url;
    navigator.clipboard
      .writeText(link)
      .then(() => {
        console.log("Link copied to clipboard:", link);
        showSnackbar("Link copied to clipboard", "success");
      })
      .catch((error) => {
        console.error("Error copying link to clipboard:", error);
        showSnackbar("Error copying link to clipboard:", "error");
      });
  };

// Cancel Mis Payment
  const handleCancelMiscPayment = async () => {


    const requestData = {
      user_id: parseInt(userId),
       miscellaneous_fee_id: selectedMisRowId,
      approval_status: "cancelled",
    };

    try {
      const response = await fetch(
        `${API_ENDPOINT}miscellaneousfees/updateapprovalstatus`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json", // Make sure to keep the content type
          },
          body: JSON.stringify(requestData),
        }
      );

      if (response.ok) {
        showSnackbar("Data Updated Successfully", "success");
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      } else if (response.status === 400) {
        showSnackbar("Please pass a valid approval status", "error");
      } else if (response.status === 401) {
        showSnackbar("Unauthorized User", "error");
      } else if (response.status === 405) {
        showSnackbar("Miscellaneous fee ID cannot be null", "error");
      } else if (response.status === 404) {
        showSnackbar("No active miscellaneous payment with this id", "error");
      } else if (response.status === 500) {
        showSnackbar("Server Error", "error");
      } else {
        showSnackbar("Server Error", "error");
      }
    } catch (error) {
      showSnackbar("Server Error", "error");
    }
  };

  return (
    <>
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
      <Typography textAlign="left" variant="h4" fontWeight={700}>
        Payment History
      </Typography>
      </Grid>

      <Grid item xs={12}>
      {loading ? (
        <Grid container justifyContent="center" alignItems="center">
          <CircularProgress />
        </Grid>
      ) : (
        <>
          {payments.length === 0 ? (
            <Grid
              item
              xs={12}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Typography variant="h5">No payment history available</Typography>
            </Grid>
          ) : (
            <StyledTableContainer
              component={Paper}
          sx={{tableLayout:"fixed"}}
     
            >
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell>Class/Program Details</TableCell>
                    <TableCell>Package</TableCell>
                    <TableCell>Currency</TableCell>
                    <TableCell>Paid Amount</TableCell>
                    <TableCell>Discount</TableCell>
                    <TableCell>Pending Amount</TableCell>
                    <TableCell>Date</TableCell>
                    <TableCell>Payment Mode</TableCell>
                    <TableCell>Collected_by</TableCell>
                    <TableCell>Payment Status</TableCell>
                    <TableCell>Action</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {payments.map((row, index) =>  {
                    console.log("payments", row)

                   // Find the most recent payment in the same group
  const latestPayment = [...payments]
    .filter(p => (
      p.enquiry_id === row.enquiry_id &&
      p.class_id?.id === row.class_id?.id &&
      p.package_id?.id === row.package_id?.id 
          // p.is_class_extension === 0 // or === false depending on your data
          // just commented this line because payment was not showing
    ))
    .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))[0]; // latest by date
  
  const isLatestInGroup = row.id === latestPayment.id;

                    return(
                    <TableRow
                      key={index}
                      style={{
                        backgroundColor:
                          index % 2 === 0 ? "#f0f0f0" : "inherit",
                        width: "6%",
                      }}
                    >
                      <TableCell>{row?.service_id == 1 ? row?.class_id?.name : row?.scholars_program_id?.name }</TableCell>
                      <TableCell
                        style={{ display: "flex", flexDirection: "column" }}
                      >
                        {row?.is_class_extension ? (
                          "Class Extension"
                        ) : (
                          <>
                            <strong>{row?.package_id?.package_name}</strong>
                            <Typography variant="h6" color="textSecondary">
                              {row?.package_id?.testType?.name || ""}{" "}
                              {row?.package_id?.subTestType?.name
                                ? `(${row?.package_id?.subTestType?.name})`
                                : ""}
                            </Typography>
                          </>
                        )}
                      </TableCell>
                      <TableCell>{row?.currency}</TableCell>
                      <TableCell>{row?.amount_paid}</TableCell>
                      <TableCell>
                        {row?.discount_amount !== null
                          ? row.discount_amount
                          : 0}
                      </TableCell>
                      <TableCell>
                        {row?.pending_amount !== null ? row.pending_amount : 0}
                      </TableCell>
                      <TableCell>{fDate(row?.payment_date)}</TableCell>
                      <TableCell>
                        {row?.payment_mode_id?.payment_mode}
                      </TableCell>
                      <TableCell>
                        {row?.collected_by?.first_name} {row?.collected_by?.last_name}
                      </TableCell>
                      <TableCell>
                        <Chip
                        size="small"
                        variant="contained"
                          label={row?.payment_status}
                          color={
                            row?.payment_status === "paid"
                              ? "secondary"
                              : "error"
                          }
                        />
                      </TableCell>
                      <TableCell>
                        {row.payment_status === "pending" && (
                          <>
                            <Tooltip title="Cancel Payment Request" arrow>
                              <IconButton
                                color="error"
                                onClick={() => handleCancelPayment(row.id)}
                              > 
                                <CancelIcon  fontSize="small" style={{fontSize:'0.7rem'}}/>
                              </IconButton>
                            </Tooltip>
                          </>
                        )}
                        {row.payment_status === "pending" &&
                          row?.payment_link_object?.status === "expired" && row?.payment_mode_id?.payment_mode==="Razorpay" && (
                            <>
                              <Tooltip title="Generate New Link" arrow>
                                <IconButton
                                  color="secondary"
                                  onClick={() =>
                                    handleGenerateNewPaymentLink(row)
                                  }
                                >
                                  <PaymentIcon fontSize="small" style={{fontSize:'0.7rem'}}/>
                                </IconButton>
                              </Tooltip>
                            </>
                          )}
                        {row.payment_status === "pending" &&
                          row?.payment_link_object?.short_url && row?.payment_mode_id?.payment_mode==="Razorpay" && (
                            <>
                              <Tooltip title="Copy Payment Link" arrow>
                                <IconButton
                                  color="primary"
                                  onClick={() => copyLinkToClipboard(row)}
                                >
                                  <ContentCopyIcon fontSize="small" style={{fontSize:'0.7rem'}}/>
                                </IconButton>
                              </Tooltip>
                            </>
                          )}
                        {row?.payment_status === "paid" &&
                          row?.receipt_id !== null && (
                            <Link
                              to={`/receipt/${row?.receipt_id?.ref_number}`}
                              target="_blank"
                            >
                              <Tooltip title="Download Receipt" arrow>
                                <IconButton
                                  color="primary"
                                  disabled={isReadOnly}
                                >
                                  <ReceiptIcon fontSize="small" style={{fontSize:'0.9rem'}}/>
                                </IconButton>
                              </Tooltip>
                            </Link>
                          )}
                         

                        {row.payment_status === "paid" &&
                          row?.pending_amount>0 &&    isLatestInGroup &&  (
                            <>
                              <Tooltip
                                title="Generate new pending payment request"
                                arrow
                              >
                                <IconButton
                                  color="secondary"
                                  onClick={() => handleOpen(row)}
                                  disabled={isReadOnly}
                                >
                                  <PaymentIcon fontSize="small" style={{fontSize:'0.9rem'}}/>
                                </IconButton>
                              </Tooltip>

                              <PaymentPopup
                                open={open}
                                title="Generate Payment"
                                handleClose={handleClose}
                                rowData={selectedRow}
                                // content={<PaymentForm rowData={selectedRow} />}
                              />
                           

                   
                              <Tooltip
                                title="Plan Status"
                                arrow
                              >
                                <IconButton
                                  color="error"
                                  onClick={() => handleOpenPlanStatus(row)}
                                  disabled={isReadOnly}
                                >
                                  <ArrowDropDownCircleIcon fontSize="small" style={{fontSize:'0.9rem'}} />
                                </IconButton>
                              </Tooltip>

                              <PlanStatusForm
                                open={openPlanStatus}
                                title="Pending Payment Status"
                                handleClose={handleClosePlanStatus}
                                rowData={selectedRow}
                              />
                            </>
                          )}
                      </TableCell>
                    </TableRow>
                  )})}
                </TableBody>
              </Table>
            </StyledTableContainer>
          )}
        </>
      )}
      </Grid>
      </Grid>
</Grid>

{(([4,9,5,7]).includes(selectedSubService) && miscellaneousPayment.length >0) && (
   <Grid item xs={12}>
    <Grid container spacing={2}>
      <Grid item xs={12}>
<Typography textAlign="left" variant="h4" fontWeight={700}>
        Miscellaneous Payment History
      </Typography>
      </Grid>
      <Grid item xs={12}>
      {miscellaneousPaymentLoading ? (
        <Grid container justifyContent="center" alignItems="center">
          <CircularProgress />
        </Grid>
      ) : (
        <>
          {miscellaneousPayment.length === 0 ? (
            <Grid
              item
              xs={12}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <Typography variant="h5">No payment history available</Typography>
            </Grid>
          ) : (
            <StyledTableContainer
              component={Paper}
              sx={{tableLayout:"fixed"}}
              
            >
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    <TableCell>Test Type</TableCell>
                     
                    <TableCell> {selectedSubService===4 ? "PTE Id" : selectedSubService===9? "TOEFL Id" : selectedSubService===7?"GRE Id" : selectedSubService===5 ?"Duolingo Id":""}</TableCell>
                    <TableCell>Currency</TableCell>
                    <TableCell>Test Fees</TableCell>
                    <TableCell>Paid Amount</TableCell>
                     <TableCell>Voucher Amount</TableCell>
                           <TableCell>Revenue Generated</TableCell>
                    <TableCell>Payment Date</TableCell>
                 
                    <TableCell>Payment Status</TableCell>
                      <TableCell>Action</TableCell>
                   
                  </TableRow>
                </TableHead>
                <TableBody>
                  {miscellaneousPayment.map((row, index) => (
                    <TableRow
                      key={index}
                      style={{
                        backgroundColor:
                          index % 2 === 0 ? "#f0f0f0" : "inherit",
                        width: "6%",
                      }}
                    >
                     
                      <TableCell>{row?.test_type_id?.name} <br></br> {row?.sub_test_type_id?.name ? `(${row?.sub_test_type_id?.name })` : ""} </TableCell>
                        
                      <TableCell>
                        {row?.pte_id}
                      </TableCell>
                      <TableCell>
                        {row?.currency}
                      </TableCell>
                              <TableCell>
                        {row?.test_fees}
                      </TableCell>

                               <TableCell>
                        {row?.paid_amount}
                      </TableCell>

                      
                               <TableCell>
                        {row?.voucher_amount}
                      </TableCell>
                              <TableCell>
                        {row?.revenue_amount}
                      </TableCell>
                      <TableCell>{fDate(row?.createdAt)}</TableCell>
                      
                      <TableCell>
                        <Chip
                        size="small"
                        variant="contained"
                          label={row?.approval_status}
                          color={row?.approval_status ==="pending" ? "warning": row?.approval_status==="approved" ? "secondary" : row?.approval_status==="cancelled" ? "primary" : "error"}
                        />
                      </TableCell>

                      <TableCell> {row.approval_status === "pending" && (
                        
                            <Tooltip title="Cancel Payment Request" arrow>
                              <IconButton
                                color="error"
                               onClick={() => handleOpenCancelPopup(row?.id)}
                              > 
                                <CancelIcon  fontSize="small" style={{fontSize:'0.7rem'}}/>
                              </IconButton>
                            </Tooltip>
                      )}
                      
                      {row?.approval_status === "approved" &&
                          row?.receipt_id !== null && (
                            <Link
                              to={`/mis-receipt/${row?.receipt_ref_id?.ref_number}`}
                              target="_blank"
                            >
                              <Tooltip title="Download Receipt" arrow>
                                <IconButton
                                  color="primary"
                                  disabled={isReadOnly}
                                >
                                  <ReceiptIcon fontSize="small" style={{fontSize:'0.9rem'}}/>
                                </IconButton>
                              </Tooltip>
                            </Link>
                          )}

                      </TableCell>
                    
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </StyledTableContainer>
          )}
        </>
      )}
      </Grid>
      </Grid>
      </Grid>
       ) }
      </Grid>
      <Dialog open={newLinkdialogOpen} onClose={handlenewLinkCloseDialog}>
        <DialogTitle variant="h4">Generate New Payment Link</DialogTitle>
        <DialogContent>
          <Typography>
            Would you like to generate a new payment link for{" "}
            {selectedRow?.class_id?.name} for payment of Rs{" "}
            {selectedRow?.amount_paid}?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            color="error"
            onClick={handlenewLinkCloseDialog}
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="secondary"
            onClick={handleGeneratePaymentLink}
          >
            Generate
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={refundDialogOpen}
        onClose={handleRefundDialogClose}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle variant="h2">Initiate Refund</DialogTitle>
        <DialogContent>
          <Grid container spacing={4}>
            <Grid item xs={12} md={12}>
              <FormControl component="fieldset">
                <RadioGroup
                  aria-label="refund-type"
                  name="refund-type"
                  value={refundType}
                  onChange={(e) => setRefundType(e.target.value)}
                >
                  <FormControlLabel
                    value="full"
                    control={<Radio />}
                    label="Full Refund"
                  />
                  <FormControlLabel
                    value="partial"
                    control={<Radio />}
                    label="Partial Refund"
                  />
                </RadioGroup>
              </FormControl>
            </Grid>

            {refundType === "partial" && (
              <>
                <Grid item xs={12} md={12}>
                  <TextField
                    label="Refund Amount (INR)"
                    type="number"
                    fullWidth
                    value={refundAmount}
                    onChange={(e) => setRefundAmount(e.target.value)}
                  />
                </Grid>
              </>
            )}

            <Grid item xs={12} md={12}>
              <InputLabel id="refund-reason-label">Refund Reason</InputLabel>
              <Select
                labelId="refund-reason-label"
                id="refund-reason"
                fullWidth
                value={refundReason}
                onChange={(e) => setRefundReason(e.target.value)}
              >
                <MenuItem value="product-defect">Unavailable</MenuItem>
                <MenuItem value="change-mind">Change of Mind</MenuItem>
              </Select>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleRefundDialogClose} color="primary">
            Cancel
          </Button>
          <Button
            onClick={handleRefundSubmit}
            color="secondary"
            variant="contained"
          >
            Submit Refund Request
          </Button>
        </DialogActions>
      </Dialog>

      <CustomSnackbar
        open={snackbarOpen}
        onClose={() => setSnackbarOpen(false)}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />

       <CustomPopup
              open={opencancel}
              onClose={handleCloseCanclePopup}
              component={
                <CancelPayment
                  handleCancelPayment={handleCancelMiscPayment}
                  onClose={handleCloseCanclePopup}
                />
              }
              showDivider={true}
              title="Confirmation"
              maxWidth="xs"
            />
    </>
  );
}

export default EnquiryPayments;
